const TAX_CATEGORIES = {
	Alberta: ["GST 5%", "Exempt"],
	"British Columbia": ["GST & PST 12%", "M&E 2.5%", "Exempt"],
	Manitoba: ["GST 5%", "PST 7%", "M&E 2.5%", "Exempt"],
	"New Brunswick": ["HST 15%", "M&E 7.5%", "Exempt"],
	"Newfoundland and Labrador": ["HST 15%", "M&E 7.5%", "Exempt"],
	"Northwest Territories": ["GST 5%", "Exempt"],
	"Nova Scotia": ["HST 15%", "M&E 7.5%", "Exempt"],
	Nunavut: ["GST 5%", "Exempt"],
	Ontario: ["HST 13%", "M&E 6.5%", "Exempt"],
	"Prince Edward Island": ["HST 15%", "M&E 7.5%", "Exempt"],
	Quebec: ["GST 5%", "QST 9.975%", "M&E 2.5%", "M&E 4.9875%", "Exempt"],
	Saskatchewan: ["GST 5%", "PST 6%", "M&E 2.5%", "Exempt"],
	Yukon: ["GST 5%", "Exempt"]
};

const TAX_CARRIED_BY_LABEL = {
	"GST 5%": { priceIncludesRate: 5, gstHstRate: 5, recoverableShare: 1, provincialRate: 0 },
	"HST 13%": { priceIncludesRate: 13, gstHstRate: 13, recoverableShare: 1, provincialRate: 0 },
	"HST 15%": { priceIncludesRate: 15, gstHstRate: 15, recoverableShare: 1, provincialRate: 0 },
	"GST & PST 12%": { priceIncludesRate: 12, gstHstRate: 5, recoverableShare: 1, provincialRate: 7 },
	"PST 7%": { priceIncludesRate: 7, gstHstRate: 0, recoverableShare: 0, provincialRate: 7 },
	"PST 6%": { priceIncludesRate: 6, gstHstRate: 0, recoverableShare: 0, provincialRate: 6 },
	"QST 9.975%": { priceIncludesRate: 9.975, gstHstRate: 0, recoverableShare: 0, provincialRate: 9.975 },
	"M&E 2.5%": { priceIncludesRate: 5, gstHstRate: 5, recoverableShare: 0.5, provincialRate: 0 },
	"M&E 4.9875%": { priceIncludesRate: 9.975, gstHstRate: 0, recoverableShare: 0.5, provincialRate: 9.975 },
	"M&E 6.5%": { priceIncludesRate: 13, gstHstRate: 13, recoverableShare: 0.5, provincialRate: 0 },
	"M&E 7.5%": { priceIncludesRate: 15, gstHstRate: 15, recoverableShare: 0.5, provincialRate: 0 },
};

const LABELS_MEANING_NO_TAX = ["", "exempt", "no tax", "zero-rated", "out of scope"];

const TAX_NOT_SPLIT_REASONS = {
	NO_GST_HST_ACCOUNT_ON_CHART: "no_gst_hst_account_on_chart",
	CLASSIFIED_TO_A_TAX_ACCOUNT: "classified_to_a_tax_account",
	LABEL_CARRIES_NO_GST_HST: "label_carries_no_gst_hst",
	PST_PORTION_LEFT_IN_PLACE: "pst_portion_left_in_place",
	NOT_YET_CLASSIFIED: "not_yet_classified",
	RESTRICTED_CREDIT_LABEL_ON_MONEY_IN: "restricted_credit_label_on_money_in",
};

export { TAX_CARRIED_BY_LABEL, LABELS_MEANING_NO_TAX, TAX_NOT_SPLIT_REASONS };
export default TAX_CATEGORIES;
